
export const USER_INFO_COOKIE_NAME = 'user_info';
export const REFRESH_TOKEN_COOKIE_NAME = 'refresh_token';
export const REFRESH_TOKEN_EXPIRES_AT_COOKIE_NAME = 'refresh_token_expires_at';
export const AUTH_TOKEN_EXPIRY_BUFFER_MS = 60_000;
